import il8n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./translation/en.json";
import translationTA from "./translation/ta.json";

const resources = {
  en: {
    translation: translationEN,
  },
  ta: {
    translation: translationTA,
  },
};

il8n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default il8n;
